import pythonApiClient from './pythonBaseApi';

const base = '/rrhh/boletas';

const descargarBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const boletasPlanillaApi = {
  downloadModeloFormatoFijo: async (filename = 'planilla_formato_referencia.xlsx') => {
    const res = await pythonApiClient.get(`${base}/formato/modelo-excel`, {
      responseType: 'blob',
    });
    descargarBlob(res.data, filename);
  },

  validateCarga: (formData) =>
    pythonApiClient.post(`${base}/carga/validate`, formData),

  guardarCarga: (formData) =>
    pythonApiClient.post(`${base}/carga`, formData),

  getLotes: (proyectoId) =>
    pythonApiClient.get(`${base}/carga/lotes?proyecto_id=${proyectoId}`),

  getRegistrosLote: (loteId) =>
    pythonApiClient.get(`${base}/carga/lotes/${loteId}/registros`),

  getGeneracionesRegistro: (registroId) =>
    pythonApiClient.get(`${base}/carga/registros/${registroId}/generaciones`),

  getGeneracionesLote: (loteId) =>
    pythonApiClient.get(`${base}/carga/lotes/${loteId}/generaciones`),

  generarPdf: (registroIds) =>
    pythonApiClient.post(
      `${base}/generar/pdf`,
      { registro_ids: registroIds },
      { responseType: 'blob' }
    ),

  generarPdfLote: (loteId) =>
    pythonApiClient.post(`${base}/generar/pdf/lote/${loteId}`, null, {
      responseType: 'blob',
    }),
};

export default boletasPlanillaApi;
